import React from "react";
import styles from "./HeadingComponent.module.css";
const HeadingComponent = (props) => {
  return (
    <span
      id={props?.id}
      {...props}
      ref={props?.ref}
      className={`${styles.text} ${props?.className}`}
      onClick={props.onClick}
 
    >
      {props.text}
      {props.children}
    </span>
  );
};

export default HeadingComponent;
